import { useTheme } from '@mui/material';
import { signOut } from 'firebase/auth';
import LogoutIcon from '@mui/icons-material/Logout';
import { auth } from '../../utils/firebase';

// Small, unobtrusive sign-out control shared by the dashboard and every
// sub-dashboard - deliberately not another big card like the real admin
// actions next to it.
const SignOutLink = () => {
    const theme = useTheme();

    return (
        <button
            type="button"
            onClick={() => signOut(auth)}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                background: 'none',
                border: 'none',
                padding: 0,
                fontFamily: theme.typography.fontFamily,
                fontSize: '13px',
                fontWeight: 600,
                color: theme.palette.text.secondary,
                cursor: 'pointer',
            }}
        >
            <LogoutIcon sx={{ fontSize: '16px' }} />
            Sign Out
        </button>
    );
};

export default SignOutLink;
